import React, { useState, useEffect, useContext } from "react";
import { Line } from "react-chartjs-2";
import Select from "react-select";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { UrlContext } from "../contexts/UrlContext";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// Time period options
const PERIOD_OPTIONS = [
  { value: "7daysAgo", label: "Last Week" },
  { value: "30daysAgo", label: "Last Month" },
  { value: "365daysAgo", label: "Last Year" },
];

const Analytics = () => {
  const [selectedEvent, setSelectedEvent] = useState("Login with email");
  const [selectedPeriod, setSelectedPeriod] = useState(PERIOD_OPTIONS[0]); // Default: Last Week
  const [chartData, setChartData] = useState(null);
  const { URI } = useContext(UrlContext);

  // Fetch event data from backend
  const fetchEventData = async () => {
    try {
      const pageview =
        selectedEvent == "profile" ||
        selectedEvent == "projects" ||
        selectedEvent == "invitations";
      const response = await fetch(
        `${URI}analytics/${
          pageview ? "visits?pageview=" : "events?event="
        }${encodeURIComponent(selectedEvent)}&period=${encodeURIComponent(
          selectedPeriod.value
        )}`
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      // Set chart data
      setChartData({
        labels: data.labels, // Dates or months
        datasets: [
          {
            label: `Occurrences of ${selectedEvent}`,
            data: data.counts, // Number of events per period
            borderColor: "rgb(75, 192, 192)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
          },
        ],
      });
    } catch (error) {
      console.error("Error fetching data from backend:", error);
    }
  };

  // Fetch data whenever the event or period changes
  useEffect(() => {
    fetchEventData();
  }, [selectedEvent, selectedPeriod]);

  return (
    <div>
      <h2>Google Analytics</h2>

      {/* Event selection dropdown */}
      <Select
        options={[
          { value: "Login with Linkedin", label: "Login with Linkedin" },
          { value: "Login with email", label: "Login with email" },
          { value: "Apply to project", label: "Apply to project" },
          { value: "Load profile", label: "Load profile" },
          { value: "Remove Application", label: "Remove Application" },
          { value: "Quit a project", label: "Quit a project" },
          { value: "Recover Password", label: "Recover Password" },
          { value: "profile", label: "Visits to profile" },
          { value: "projects", label: "Visits to projects" },
          { value: "invitations", label: "Visits to invitations" },
        ]}
        value={{ value: selectedEvent, label: selectedEvent }}
        onChange={(option) => setSelectedEvent(option.value)}
      />

      {/* Time period selection buttons */}
      <div style={{ marginTop: "10px" }}>
        {PERIOD_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => setSelectedPeriod(option)}
            style={{
              marginRight: "10px",
              padding: "10px",
              backgroundColor:
                selectedPeriod.value === option.value ? "#28a745" : "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {option.label}
          </button>
        ))}
      </div>

      {/* Display chart */}
      {chartData ? <Line data={chartData} /> : <p>Loading data...</p>}
    </div>
  );
};

export default Analytics;
